import { useEffect, useRef } from 'react';

import * as api from '@test_prep/app/api';

const POLL_INTERVAL_MS = 2000;
const MAX_POLLS = 30;

interface Props {
  responseId: number;
  retryId: number;
  onUpdated: (updatedRetry: any) => void;
}

const RetryPolling = ({ responseId, retryId, onUpdated }: Props) => {
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const pollCountRef = useRef(0);

  useEffect(() => {
    pollCountRef.current = 0;

    intervalRef.current = setInterval(async () => {
      pollCountRef.current += 1;

      if (pollCountRef.current >= MAX_POLLS) {
        clearInterval(intervalRef.current!);
        intervalRef.current = null;
        onUpdated({ id: retryId, status: 'error' });
        return;
      }

      const updatedRetry = await api.fetchGradingRequestResponseRetry(responseId, retryId);

      if (updatedRetry.status === 'finished' || updatedRetry.status === 'error') {
        clearInterval(intervalRef.current!);
        intervalRef.current = null;
      }

      onUpdated(updatedRetry);
    }, POLL_INTERVAL_MS);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [responseId, retryId]);

  return null;
};

export default RetryPolling;
